import type { ReactNode } from "react";
import {
  Avatar,
  Box,
  Container,
  CssBaseline,
  Paper,
  Typography,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export function LoginLayout({
  image,
  children,
  showLegal = true,
}: {
  image: string;
  children: ReactNode;
  showLegal?: boolean;
}) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "url(" + image + ") center center",
        backgroundSize: "cover",
      }}
    >
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Paper
          sx={{
            px: 3,
            pt: 2,
            pb: 2,
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Anmelden
          </Typography>
          {children}
          {showLegal && (
            <Box sx={{ fontSize: "14px" }}>
              <a href="https://www.juchem-gruppe.de/impressum" target="_blank">
                Impressum
              </a>{" "}
              &ndash;{" "}
              <a
                href="https://www.juchem-gruppe.de/datenschutz"
                target="_blank"
              >
                Datenschutz
              </a>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
}
